import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { buildCommonConfig } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/hooks/useEnrollmentSubmit";
import { EnrollmentConfigState } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/types";
import { CatalogEntityType } from "@pages/Contents/V2/Corporate/Catalog/types";

export interface UserLoSelection {
  id: number;
  kind: CatalogEntityType;
  title: string;
  entity: Record<string, any>;
}

interface SubmitArgs {
  corporateId: string | number;
  userId: string | number;
  los: UserLoSelection[];
  config: EnrollmentConfigState;
}

export const useUserEnrollmentSubmit = () => {
  const { trigger: postEnrollments, isMutating } = useSWRMutation(
    ServicesURL.postEnrollment,
    (url: string, { arg }: { arg: any[] }) =>
      fetcher<any>(url, MethodType.POST, arg),
  );

  const submit = async ({ corporateId, userId, los, config }: SubmitArgs) => {
    if (!userId || los.length === 0) return;
    const common = buildCommonConfig(config);
    const payload = los.map((lo) => ({
      ...common,
      learningObject: {
        corporateId: Number(corporateId),
        objectId: lo.id,
      },
      userId: Number(userId),
      domainId: null,
      massiveDomainId: null,
      massiveGroupId: null,
    }));
    await postEnrollments(payload);
  };

  return { submit, isSubmitting: isMutating };
};
